import React from "react";
import Frame from "react-frame-component";
import { useSelector } from "react-redux";
import SizeSelector from "../utils/size-selector";

const selectors = [
  { icon: "desktop", title: "Desktop 918 x 110", width: 900 },
  { icon: "laptop", title: "Laptop 724 x 110", width: 724 },
  { icon: "tablet", title: "Tablet 532 x 110", width: 532 },
  { icon: "mobile-mpu", title: "Mobile 375 x 258", width: 375 },
];

const aspectRatioMap = {
  desktop: "28.2%",
  laptop: "35.4%",
  tablet: "35.4%",
  "mobile-mpu": "53%",
};

const BuylistHeader = ({ banner }) => {
  const divClass = useSelector((state) => state.divClass || "desktop");
  const deviceClass = divClass.split(" ")[0];
  const paddingBottom = aspectRatioMap[deviceClass] || aspectRatioMap.desktop;

  return (
    <SizeSelector selectors={selectors}>
      <div className="buylist-header">
        <Frame
          initialContent={`<!DOCTYPE html><html><head><link
          href="${process.env.PUBLIC_URL}/static/css/brand.css?v=7"
          rel="stylesheet"
        /></head><body><div id="bannerFrame"></div></body></html>`}
          mountTarget="#bannerFrame"
        >
          <div className={`buylist-header ${deviceClass}`}>
            <div
              className="trade-tile trade-tile--page-header"
              style={{ width: "100%" }}
            >
              <span
                className="tile__image-container"
                style={{
                  display: "block",
                  height: 0,
                  position: "relative",
                  width: "100%",
                  paddingBottom,
                }}
              >
                <span
                  id="responsive-background--0"
                  className="responsive-background tile__image"
                  style={{
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                  }}
                >
                  <img
                    src={banner.buylistHeader.path}
                    alt=" "
                    className="responsive-background--image tile__image"
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </span>
              </span>
            </div>
          </div>
        </Frame>
      </div>
    </SizeSelector>
  );
};

export default BuylistHeader;
